<template>
    <div>
      <Card>
        <p slot="title">设置信息</p>
        <div slot="extra">
          <Button v-if="imgUrl.length <= 0" type="primary" @click="GetDate">生成小程序码</Button>
          <Button v-if="imgUrl.length > 0" type="info" @click="EditHandle">{{IsRemarks ? '备注确定' : '编辑备注'}}</Button>
          <Button v-if="imgUrl.length > 0" type="info" style="margin-left: 2rem" @click="ResetHandle">重置</Button>
        </div>
        <Form ref="FormData" :model="FormData" :rules="ruleCustom" :label-width="85" :hide-required-mark="imgUrl.length > 0" @submit.native.prevent>
          <Row>
            <Col :xs="24" :sm="12" :md="12" :lg="8">
                <FormItem label="物料编码:" prop="ProductID">
                  <Input v-if="imgUrl.length === 0" v-model="FormData.ProductID" search enter-button="选择" readonly
                  @on-search="ProductSelectHandle"></Input>
                  <p v-else>{{FormData.ProductID}}</p>
                </FormItem>
            </Col>
            <Col :xs="24" :sm="12" :md="12" :lg="8">
                <FormItem label="物料名称:">
                  <p>{{FormData.ProductName}}</p>
                </FormItem>
            </Col>
            <Col :xs="24" :sm="12" :md="12" :lg="8">
                <FormItem label="属性汇总:">
                  <p>{{FormData.Attribute_Summary}}</p>
                </FormItem>
            </Col>
            <Col :xs="24" :sm="12" :md="12" :lg="8">
                <FormItem label="单重:" prop="SingleWeight">
                  <Select v-if="imgUrl.length === 0" v-model="FormData.SingleWeight">
                    <Option v-for="item in SingleWeightList" :value="item.SingleWeight" :key="item.SingleWeight">{{item.SingleWeight}}</Option>
                  </Select>
                  <p v-else>{{FormData.SingleWeight}}</p>
                </FormItem>
            </Col>
            <Col :xs="24" :sm="12" :md="12" :lg="8">
                <FormItem label="辅助数量:" prop="AuxiliaryQty">
                  <Select v-if="imgUrl.length === 0" v-model="FormData.AuxiliaryQty" transfer>
                    <Option v-for="item in AuxiliaryQtyList" :value="item.AuxiliaryQuantity" :key="item.AuxiliaryQuantity">{{item.AuxiliaryQuantity}}</Option>
                  </Select>
                  <p v-else>{{FormData.AuxiliaryQty}}</p>
                </FormItem>
            </Col>
            <Col :xs="24" :sm="12" :md="12" :lg="8">
                <FormItem label="配送方式:" prop="Distribution">
                  <Select v-if="imgUrl.length === 0" v-model="FormData.Distribution" transfer>
                    <Option v-for="item in DistributionList" :value="item.Name" :key="item.Name">{{item.Name}}</Option>
                  </Select>
                   <p v-else>{{FormData.Distribution}}</p>
                </FormItem>
            </Col>
            <Col :xs="24" :sm="12" :md="12" :lg="8" v-if="imgUrl.length > 0 && IsRemarks">
                <FormItem label="备注：">
                  <Input v-model="Remarks" placeholder="小程序码备注..."></Input>
                </FormItem>
            </Col>
          </Row>
        </Form>
        <div style="width:100%;text-align:center" v-if="imgUrl.length > 0">
          <img :src="imgUrl"/>
          <p style="margin-top:.5rem;font-size:1rem" v-if="!IsRemarks">{{Remarks}}</p>
        </div>
      </Card>

      <ProductInfolist v-if="ProductModal" :modal="ProductModal" @ProductInfoSetModal="ProductInfoSetModal"
      @SelecttionHandleClick="SelecttionHandleClick"/>
    </div>
</template>

<script>
import { GetWxaCode, GetWxbCodeSetInfo, GetDistributionMode } from '@/api/Customer'
import ProductInfolist from '@/components/ProductInfolist'
export default {
  name: 'WxCode',
  components: {
    ProductInfolist
  },
  data () {
    return {
      imgUrl: '',
      FormData: {
        ProductID: '',
        ProductName: '',
        Attribute_Summary: '',
        SingleWeight: 0,
        AuxiliaryQty: 0,
        Distribution: ''
      },
      SingleWeightList: [],
      AuxiliaryQtyList: [],
      DistributionList: [],
      ProductModal: false,
      Remarks: '',
      IsRemarks: false,
      ruleCustom: {
        ProductID: [
          { required: true, message: '请选择物料信息', trigger: 'change' }
        ],
        SingleWeight: [
          { required: true, type: 'number', min: 0.0001, message: '请选择单重', trigger: 'change' }
        ],
        AuxiliaryQty: [
          { required: true, type: 'number', min: 0.0001, message: '请选择辅助数量', trigger: 'change' }
        ],
        Distribution: [
          { required: true, message: '请选择配送方式', trigger: 'change' }
        ]
      }
    }
  },
  mounted: function () {
    this.GetDistributionList()
  },
  methods: {
    GetDate () {
      this.$refs['FormData'].validate((valid) => {
        if (valid) {
          GetWxaCode({
            ProductID: this.FormData.ProductID,
            SingleWeight: Number(this.FormData.SingleWeight),
            AuxiliaryQuantity: Number(this.FormData.AuxiliaryQty),
            Distribution: this.FormData.Distribution
          }).then(res => {
            if (res.IsSuccess) {
              this.imgUrl = 'data:image/jpeg;base64,' + res.Data
              this.Remarks = ''
            }
          })
        } else {
          this.$Message.error('请先把信息完善')
        }
      })
    },
    // 获取配送方式数据
    GetDistributionList () {
      GetDistributionMode().then(res => {
        if (res.IsSuccess) {
          this.DistributionList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    ResetHandle () {
      this.imgUrl = ''
    },
    ProductInfoSetModal (value) {
      this.ProductModal = value
    },
    ProductSelectHandle () {
      this.ProductModal = true
    },
    // 物料选择后回调
    SelecttionHandleClick (info) {
      this.FormData.ProductID = info.ProductID
      this.FormData.ProductName = info.Product_Name
      this.FormData.Attribute_Summary = info.Attribute_Summary
      this.ProductModal = false
      GetWxbCodeSetInfo(info.ProductID).then(res => {
        if (res.IsSuccess) {
          this.SingleWeightList = res.Data.Table
          this.AuxiliaryQtyList = res.Data.Table1
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    EditHandle () {
      if (this.IsRemarks) {
        this.IsRemarks = false
      } else {
        this.IsRemarks = true
      }
    }
  }
}
</script>
